export const OVERRIDE_ADD_PANEL = 'override-add-panel';
